import { render, staticRenderFns } from "./SettingsCertificatesDialog.vue?vue&type=template&id=e047c4c8"
import script from "./SettingsCertificatesDialog.vue?vue&type=script&lang=js"
export * from "./SettingsCertificatesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports